<!--
    RubberPendant 橡胶挂件
-->

<template>
  <transition name="el-fade-in-linear">
    <div>
      <el-collapse-item title="挂件 > 橡胶挂件" name="橡胶挂件">
        <el-row>
          <el-col :span="24" class="my-middle">
            <el-checkbox
              v-bind:key="select.id"
              v-for="select in rubberPendant"
              v-model="select.status"
              v-bind:label="select.name"
              style="width:150px;margin:10px"
              border
            ></el-checkbox>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-collapse v-model="forcollapse" wtfname="rubberPendantFormActive">
              <HangingRubberPendant v-if="rubberPendant[0].status"/>
              <WirerotorrRubberPendant v-if="rubberPendant[1].status"/>
              <SilicagelRubberPendant v-if="rubberPendant[2].status"/>
              <AnotherRubberPendant v-if="rubberPendant[3].status"/>
            </el-collapse>
          </el-col>
        </el-row>
      </el-collapse-item>
    </div>
  </transition>
</template>
<script>
import HangingRubberPendant from "./RubberPendant/HangingRubberPendant.vue";
import WirerotorrRubberPendant from "./RubberPendant/WirerotorrRubberPendant.vue";
import SilicagelRubberPendant from "./RubberPendant/SilicagelRubberPendant.vue";
import AnotherRubberPendant from "./RubberPendant/AnotherRubberPendant.vue";

export default {
  name: "RubberPendant",
  methods: {},
  components: {
    HangingRubberPendant,
    WirerotorrRubberPendant,
    SilicagelRubberPendant,
    AnotherRubberPendant
  },
  data() {
    return {
      forcollapse: ['橡胶挂件','绕线器','硅胶挂件','其他挂件'],
      rubberPendant: [
        { id: "HangingRubberPendant", name: "橡胶挂件", status: false },
        { id: "WirerotorrRubberPendant", name: "绕线器", status: false },
        { id: "SilicagelRubberPendant", name: "硅胶挂件", status: false },
        { id: "AnotherRubberPendant", name: "其他", status: false }
      ],
      rubberPendantFormActive: []
    };
  }
};
</script>
<style scoped>
</style>